export const selectSyiAttributes = state => state.views.syi.attributes;

export const selectCategoryAttributes = state =>
    selectSyiAttributes(state).categoryAttributes;

export const selectSuggestedAttributes = state =>
    selectSyiAttributes(state).suggestedAttributes;
